// extracted by mini-css-extract-plugin
export default {"primary":"FormButton_primary__DybQL","default":"FormButton_default__wL9Vv FormButton_primary__DybQL","link":"FormButton_link__E8d6-","spinner":"FormButton_spinner__nh3gf"};